import { render } from "./ORG_UPDATE_COVER.vue?vue&type=template&id=a2e74644"
import script from "./ORG_UPDATE_COVER.vue?vue&type=script&lang=js"
export * from "./ORG_UPDATE_COVER.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__